import React from 'react';

type Props = {
  size?: number;
};

const Space = ({ size = 1 }: Props) => <>{' '.repeat(size)}</>;

export default Space;
